module.exports = __webpack_public_path__ + "img/fantan icon 1.fb55ed99.png";